// NEW: UI_REVAMP
import dayjs from 'dayjs';
import { RECORD_GRADIENTS, RECORD_SHADOWS } from '../../../styles/recordUiTokens';
import { normalizeStatusKey } from '../../../utils/statusFormat';

export const getVoidActionEnabled = (ticket, serverTime) => {
	if (!ticket) return false;

	const normalizedStatus = normalizeStatusKey(ticket.status);
	const isVoided = ticket.isVoid === true || normalizedStatus === 'voided';
	const isDenied = ticket.isDenied === true || normalizedStatus === 'denied';

	if (isVoided || isDenied) {
		return false;
	}

	if (!ticket.date || !serverTime) {
		return false;
	}

	const voidCutoffTime = dayjs(ticket.date).add(5, 'minute');
	const voidTimeDiff = dayjs(voidCutoffTime).diff(dayjs(serverTime), 'second');

	return voidTimeDiff > 0;
};

export const getVoidButtonVisualState = (isEnabled) => {
	if (isEnabled) {
		return {
			borderColor: '#FF2C2C',
			background: RECORD_GRADIENTS.voidEnabled,
			boxShadow: RECORD_SHADOWS.voidEnabled,
			iconColor: '#F04646',
		};
	}

	return {
		borderColor: '#EAECF0',
		background: RECORD_GRADIENTS.voidDisabled,
		boxShadow: RECORD_SHADOWS.voidDisabled,
		iconColor: '#BFBFBF',
	};
};
